export const DEPARTMENTS = [
  {
    code: "93", slug: "courtier-assurance-seine-saint-denis-93", name: "Seine-Saint-Denis", article: "en Seine-Saint-Denis",
    cities: ["Saint-Denis", "Montreuil", "Aubervilliers", "Aulnay-sous-Bois", "Bobigny", "Drancy", "Pantin", "Noisy-le-Grand", "Saint-Ouen", "Bondy"],
    intro: "Notre agence est installée au 47 rue Jean Jaurès à Saint-Denis : nous accompagnons les artisans, TPE, chauffeurs VTC et particuliers de tout le département, en rendez-vous ou à distance.",
  },
  {
    code: "92", slug: "courtier-assurance-hauts-de-seine-92", name: "Hauts-de-Seine", article: "dans les Hauts-de-Seine",
    cities: ["Nanterre", "Boulogne-Billancourt", "Colombes", "Courbevoie", "Asnières-sur-Seine", "Rueil-Malmaison", "Issy-les-Moulineaux", "Levallois-Perret", "Gennevilliers", "Clichy"],
    intro: "À quelques minutes de notre agence de Saint-Denis, nous assurons les professionnels du bâtiment, commerçants, flottes et VTC des Hauts-de-Seine.",
  },
  {
    code: "94", slug: "courtier-assurance-val-de-marne-94", name: "Val-de-Marne", article: "dans le Val-de-Marne",
    cities: ["Créteil", "Vitry-sur-Seine", "Champigny-sur-Marne", "Saint-Maur-des-Fossés", "Ivry-sur-Seine", "Maisons-Alfort", "Villejuif", "Fontenay-sous-Bois", "Vincennes", "Choisy-le-Roi"],
    intro: "Artisans, entreprises du BTP, commerces et chauffeurs du Val-de-Marne : nous comparons les offres de nos compagnies partenaires pour vous trouver la meilleure couverture.",
  },
  {
    code: "95", slug: "courtier-assurance-val-d-oise-95", name: "Val-d'Oise", article: "dans le Val-d'Oise",
    cities: ["Argenteuil", "Cergy", "Sarcelles", "Garges-lès-Gonesse", "Pontoise", "Franconville", "Goussainville", "Bezons", "Ermont", "Villiers-le-Bel"],
    intro: "Du sud au nord du Val-d'Oise, nous accompagnons les professionnels et les particuliers avec des devis rapides et un conseiller dédié.",
  },
  {
    code: "75", slug: "courtier-assurance-paris-75", name: "Paris", article: "à Paris",
    cities: ["Paris 1er à 4e", "Paris 8e", "Paris 10e", "Paris 11e", "Paris 12e", "Paris 13e", "Paris 15e", "Paris 17e", "Paris 18e", "Paris 19e et 20e"],
    intro: "Indépendants, sociétés, artisans et chauffeurs VTC parisiens : nous vous conseillons par téléphone, en visio ou à notre agence, à 10 minutes de Paris.",
  },
  {
    code: "971", slug: "courtier-assurance-guadeloupe-971", name: "Guadeloupe", article: "en Guadeloupe",
    cities: ["Pointe-à-Pitre", "Les Abymes", "Baie-Mahault", "Le Gosier", "Sainte-Anne", "Le Moule", "Petit-Bourg", "Basse-Terre", "Capesterre-Belle-Eau", "Saint-François"],
    intro: "Nous accompagnons aussi les professionnels et les particuliers de Guadeloupe, avec les mêmes compagnies partenaires et un suivi à distance.",
  },
];

export const deptBySlug = (slug) => DEPARTMENTS.find((d) => d.slug === slug);
